<template>
  <div class="h-100 d-flex ai-center">
    <div class="x-header-link-container m-l-auto">
      <router-link
          :to="{ name: 'login'}"
          tag="button"
          class="text-semibold btn-secondary BUTTON"
          selenium="dashboard-button">
        Login To Your Account
      </router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app-header-tos',

  computed: {
    isWhiteHeader () {
      return this.$route.name === 'homepage' || this.$route.name === 'consumer::dashboard';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  @import "~@/views/Dashboard/tools";

  .BUTTON {
    @include desktop-hover(color, $color-depot, darken( $color-depot, 5%));
    background-color: white;
    border:2px solid $color-depot ;
    color: $color-depot;
  }
</style>
